import { render, staticRenderFns } from "./gender.vue?vue&type=template&id=2cad8ff1&scoped=true"
import script from "./gender.vue?vue&type=script&lang=js"
export * from "./gender.vue?vue&type=script&lang=js"
import style0 from "./gender.vue?vue&type=style&index=0&id=2cad8ff1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cad8ff1",
  null
  
)

export default component.exports